import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';
export default grapesjs.plugins.add('messaging', (editor, opts = {}) => {
  let options = opts || {};

  let defaults = {
    pfx: 'messaging',
    blocks: ['messaging'],
    defaultStyle: true,
    label: 'Message',
    category: 'Advanced',
    type: 'messaging',
  };

  for (let name in defaults) {
    if (!(name in options)) options[name] = defaults[name];
  }

  loadComponents(editor, options);
  loadBlocks(editor, options);
});
